import { Tab } from '@headlessui/react';
import clsx from 'clsx';

interface ListTabProps {
  label: string;
}

const listTab: ListTabProps[] = [
  {
    label: 'Content Policy',
  },
];

const TermsTabList = () => {
  return (
    <Tab.List className="flex w-full flex-row">
      {listTab.map((item: ListTabProps) => (
        <Tab
          key={item.label}
          className={({ selected }) =>
            clsx(
              'relative border-b-2 bg-transparent px-4 py-1 text-sm font-semibold leading-5 text-dark-navy-blue focus:outline-none',
              selected ? 'border-vivid-orange' : 'border-transparent'
            )
          }
        >
          {item.label}
        </Tab>
      ))}
    </Tab.List>
  );
};

export default TermsTabList;
